// extracted by mini-css-extract-plugin
export default {"projectContainer":"Project_projectContainer__RxQOI","projectPages":"Project_projectPages__OwVNN"};